import { render, staticRenderFns } from "./Account.vue?vue&type=template&id=54a009fe&scoped=true&"
import script from "./Account.vue?vue&type=script&lang=js&"
export * from "./Account.vue?vue&type=script&lang=js&"
import style0 from "./Account.vue?vue&type=style&index=0&id=54a009fe&prod&lang=less&scoped=true&"
import style1 from "./Account.vue?vue&type=style&index=1&id=54a009fe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a009fe",
  null
  
)

export default component.exports